const firebaseErrors = ['Indexed Database server', 'AsyncQueue', 'IDBDatabase']

function parseFirebaseError (error) {
	const errorMessage = error && error.message

	if (firebaseErrors.includes(errorMessage || error)) {
		const customError = new Error('Server error occurred')
		customError.code = 'auth/server-error'
		throw customError
	} else if (error.code) {
		throw error
	} else {
		const customError = new Error('Error occurred')
		customError.code = 'auth/client-error'
		throw customError
	}
}

export default {
	parseError: parseFirebaseError
}
